import React from "react";

interface Props {
  question: string;
  moreInfo?: string;
  price?: string;
  yesText: string;
  noText: string;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
  currentValue: boolean;
  name: string;
  disableNoOption?: boolean;
}

const SurveyQuestion = ({
  price,
  question,
  moreInfo,
  yesText,
  noText,
  currentValue,
  name,
  disableNoOption,
  setState,
}: Props) => {
  return (
    <fieldset className="border-none m-0 p-0" data-testid={name}>
      <div className="mb-3 leading-none">
        <div className="inline-block w-9/12 mb-0 text-sm font-normal leading-none">
          {question}
          {moreInfo && (
            <p className="w-9/12 my-2 text-xs leading-tight text-gray-700 font-normal">
              {moreInfo}
            </p>
          )}
        </div>
        {price && (
          <div className="inline-block float-right mb-0 text-base leading-none">
            {price}
          </div>
        )}
      </div>
      <div className="mb-4 md:block flex flex-col">
        <label className="inline-block sm:w-3/12 w-1/3">
          <input
            type="radio"
            name={name}
            value="Yes"
            checked={currentValue}
            data-testid={`${name}-yes`}
            onChange={() => setState(true)}
          />
          {yesText}
        </label>
        <label
          className={`inline-block${disableNoOption ? " text-gray-400" : ""}`}
        >
          <input
            type="radio"
            name={name}
            value="No"
            checked={!currentValue}
            disabled={disableNoOption}
            data-testid={`${name}-no`}
            onChange={() => setState(false)}
          />
          {noText}
        </label>
      </div>
    </fieldset>
  );
};

export default SurveyQuestion;
